import useGetBookDetails, { QmsMyBookDetailsType } from './useGetBookDetails';

export default useGetBookDetails;
export type { QmsMyBookDetailsType };
